import { render, staticRenderFns } from "./IlmoitustauluHallitus.vue?vue&type=template&id=22964150&scoped=true"
import script from "./IlmoitustauluHallitus.vue?vue&type=script&lang=js"
export * from "./IlmoitustauluHallitus.vue?vue&type=script&lang=js"
import style0 from "./IlmoitustauluHallitus.vue?vue&type=style&index=0&id=22964150&prod&lang=scss&scoped=true"
import style1 from "./IlmoitustauluHallitus.vue?vue&type=style&index=1&id=22964150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22964150",
  null
  
)

export default component.exports